import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { UI } from 'components/_Assets/svg/Icon/ui'
import { Grid, GridGap } from 'components/Grid/Grid'
import Heading from 'components/Heading'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'
import Steps from 'components/Steps'

interface HowItWorksProps {
  firstIcon?: JSX.Element
  secondIcon?: JSX.Element
  thirdIcon?: JSX.Element
}

const HowItWorks: React.FC<HowItWorksProps> = props => {
  return (
    <Section type={SectionType.white} size={Size.s}>
      <Heading level={4} centered={true}>
        <DisplayContent contentKey="home-how">How it works</DisplayContent>
      </Heading>
      <br />
      <Grid nrCols={[1, 3]} colGap={[GridGap.l]} rowGap={[GridGap.xl]}>
        <Steps
          icon={props.firstIcon || SRPRS.sliders}
          heading={
            <DisplayContent contentKey="home-how-step-1">
              How it works
            </DisplayContent>
          }
          story={
            <DisplayContent contentKey="home-how-step-1-story">
              Tailor your trip down to the very last detail, so we can create
              the most jaw-dropping, awe- inspiring experience for you. Your
              exact destination will remain a surprise up until you arrive at
              the airport.
            </DisplayContent>
          }
        />

        <Steps
          icon={props.secondIcon || SRPRS.calendar()}
          heading={
            <DisplayContent contentKey="home-how-step-2">
              Discover your destination
            </DisplayContent>
          }
          story={
            <DisplayContent contentKey="home-how-step-2-story">
              To get a sense of what to pack and what not to pack, we’ll send
              you the weather forecast in advance.. After this first clue, we
              will subsequently send you your scratch card which holds the key
              to unlock your destination. All that is required from you is a
              tiny dose of patience. Only at the airport can you finally give
              into the urge of unveiling your destination.
            </DisplayContent>
          }
        />

        <Steps
          icon={props.thirdIcon || SRPRS.spark}
          heading={
            <DisplayContent contentKey="home-how-step-3">
              The trip really takes off after take-off
            </DisplayContent>
          }
          story={
            <DisplayContent contentKey="home-how-step-3-story">
              What you will experience, eat and do is all wide open at this
              point. From now on, every discovery, no matter how big or small,
              is bound to trigger a moment of marvel. With no planning ahead,
              means enjoying every moment to the fullest.
            </DisplayContent>
          }
        />
      </Grid>
    </Section>
  )
}

export default HowItWorks
